export default [
  {
    path:"/milk-analysis/:id",
    name:"Milk-analysis",
    component: () => import("@/components/adm/milk-control/FormMilkControl.vue"),
    meta: {
      title: "Controle Leiteiro > Composição do Leite"
    }
  },
  {
    path:"/milk-analysis-list",
    name:"Milk-analysis-list",
    component: () => import("@/components/adm/milk-control/MilkList.vue"),
    meta: {
      title: "Controle Leiteiro > Composição do Leite"
    }
  },
]